import { render, staticRenderFns } from "./CompanyExpenses.vue?vue&type=template&id=5dd2e892&"
import script from "./CompanyExpenses.vue?vue&type=script&lang=js&"
export * from "./CompanyExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports